import {
    declareAiCapability,
    provideAiCapability,
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

// Unlinked patients has one filter - its search box - and says so rather than leaving the omnibar to
// infer that the page has nothing.
declareAiCapability({
    id: "hhaxUnlinkedPatients.filter",
    title: "Search the HHAX unlinked patients",
    effect: "prefill",
    description:
        "Sets the free-text search on HHAX Integration > Unlinked Patients. That is the only filter this page has. Only works while that page is open.",
    location: "the search box of the HHAX Integration > Unlinked Patients page",
    scope: "page",
    permissionKey: "view_hhax_integration_section_non_billing",
    params: [
        {
            name: "search",
            type: "text",
            required: false,
            searchesFreeText: true,
            description: "Free text the table searches over every column, including patient name."
        }
    ],
    examples: ["unlinked patients called smith"]
});

//! @ngInject
export function hhaIntegrationUnlinkedPatientsCtrl(
    $scope,
    NgTableParams,
    hhaxIntegrationService
) {
    const init = () => {
        $scope.globalFilter = { val: "" };
        $scope.isLoading = true;

        hhaxIntegrationService.getUnlinkedPatients().then(res => {
            initTable(res.data.unlinkedPatients);
            $scope.isLoading = false;
        })
    }


    const initTable = (data) => {
        const options = {
            count: 25,
            sorting: { firstName: "desc" }
        };

        $scope.tableParams = new NgTableParams(options, {
            counts: [],
            dataset: data
        });
    }


    const releaseHhaxUnlinkedFilter = provideAiCapability("hhaxUnlinkedPatients.filter", (args) => {
        if (args.search === undefined) {
            return "The unlinked patients list has only a search box";
        }

        $scope.globalFilter.val = String(args.search);
        $scope.applyGlobalSearch();

        return 'Showing unlinked patients: "' + String(args.search) + '"';
    });

    $scope.$on("$destroy", releaseHhaxUnlinkedFilter);

    $scope.applyGlobalSearch = () => {
        const filter = { $: $scope.globalFilter.val };
        if ($scope.tableParams) {
          angular.extend($scope.tableParams.filter(), filter);
        }
      };

    init();
};